import { useFormContext } from 'react-hook-form'
import { TextField } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next'
import { InputProps } from 'components/inputs/types'
import { preventSpecialCharachtersEvent } from 'utils/eventHandlers'
import { removeNonAlphanumericals } from 'utils/helpers'
import IBAN from 'iban'
import { ALLOWED_IBAN_COUNTRIES } from 'components/inputs/iban/constants'

const Iban = ({ description, required }: InputProps) => {
  // React Hook Form
  const {
    formState: { errors },
    register,
    setValue
  } = useFormContext()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation'])

  return (
    <TextField
      {...register('iban', {
        required: { value: required, message: t('validation:required') },
        validate: {
          allowed: (value) =>
            (!required && !value) || ALLOWED_IBAN_COUNTRIES.includes(value.slice(0, 2)) || t('commonFormFields:iban.errors.invalidCountry'),
          valid: (value) => (!required && !value) || IBAN.isValid(value) || t('commonFormFields:iban.errors.invalid')
        }
      })}
      error={errors?.iban?.message as string}
      grid="full"
      label={t('commonFormFields:iban.label')}
      description={description}
      onKeyDown={(e) => preventSpecialCharachtersEvent(e)}
      onPaste={(e) => {
        // Format the paste value
        const formattedPasteValue = removeNonAlphanumericals(e.clipboardData.getData('text'))

        // Set the formatted value to the input & the form
        e.currentTarget.value = formattedPasteValue
        setValue('iban', formattedPasteValue)

        // Prevent the default paste behavior
        e.preventDefault()
      }}
      {...(!required && { optionalText: t('common:optional') })}
      type="text"
    />
  )
}

export default Iban
